const PrivacyPage = () => {
  const sections = [
    {
      title: '1. Verantwortliche Stelle',
      content: `Verantwortlich für die Datenverarbeitung auf dieser Website ist:\n\nThe Flow Company\nBaarerstrasse 75\n6300 Zug, Schweiz\n\nE-Mail: hello@culturecracker.io\nUID: CHE-186.180.770`
    },
    {
      title: '2. Allgemeines zur Datenverarbeitung',
      content: 'Wir nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend der gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerklärung.\n\nBei der Nutzung dieser Website werden verschiedene personenbezogene Daten erhoben. Personenbezogene Daten sind Daten, mit denen Sie persönlich identifiziert werden können.'
    },
    {
      title: '3. Datenerfassung auf dieser Website',
      content: 'Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen Kontaktdaten können Sie dem Abschnitt „Verantwortliche Stelle" entnehmen.\n\nIhre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei kann es sich z.B. um Daten handeln, die Sie in ein Kontaktformular eingeben.\n\nAndere Daten werden automatisch oder nach Ihrer Einwilligung beim Besuch der Website durch unsere IT-Systeme erfasst. Das sind vor allem technische Daten (z.B. Internetbrowser, Betriebssystem oder Uhrzeit des Seitenaufrufs). Die Erfassung dieser Daten erfolgt automatisch, sobald Sie diese Website betreten.'
    },
    {
      title: '4. Kontaktformular',
      content: 'Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.\n\nDie Verarbeitung der in das Kontaktformular eingegebenen Daten erfolgt somit ausschließlich auf Grundlage Ihrer Einwilligung. Sie können diese Einwilligung jederzeit widerrufen. Dazu reicht eine formlose Mitteilung per E-Mail an uns.'
    },
    {
      title: '5. Analyse-Tools und Werbung',
      content: 'Diese Website nutzt Google Analytics 4, einen Webanalysedienst der Google LLC. Google Analytics verwendet sog. „Cookies". Die durch das Cookie erzeugten Informationen über Ihre Benutzung dieser Website werden in der Regel an einen Server von Google übertragen und dort gespeichert.\n\nWir nutzen Cookiebot als Consent-Management-Plattform, um Ihre Einwilligung zur Datenverarbeitung einzuholen und zu verwalten.'
    },
    {
      title: '6. Ihre Rechte',
      content: 'Sie haben jederzeit das Recht, unentgeltlich Auskunft über Herkunft, Empfänger und Zweck Ihrer gespeicherten personenbezogenen Daten zu erhalten. Sie haben außerdem ein Recht, die Berichtigung oder Löschung dieser Daten zu verlangen.\n\nHierzu sowie zu weiteren Fragen zum Thema Datenschutz können Sie sich jederzeit an uns wenden: hello@culturecracker.io'
    },
    {
      title: '7. E-Mail-Versand mit Resend',
      content: 'Für den Versand von E-Mail-Benachrichtigungen nutzen wir den Dienst Resend (Resend, Inc.). Wenn Sie ein Formular auf unserer Website absenden, werden Ihre Daten über die Resend-API verarbeitet, um eine E-Mail-Benachrichtigung an uns zu senden. Die Daten werden nicht bei Resend gespeichert und dienen ausschließlich der Übermittlung.'
    }
  ];

  return (
    <main className="bg-[var(--bg-primary)] min-h-screen pt-28 sm:pt-32 pb-16 sm:pb-24">
      <div className="max-w-3xl mx-auto px-5 sm:px-8 lg:px-12">
        <p className="eyebrow mb-6">RECHTLICHES</p>
        <h1 className="h1-display text-3xl sm:text-4xl lg:text-5xl mb-4">Datenschutzerklärung</h1>
        <p className="body-sm mb-16">Letzte Aktualisierung: April 2026</p>

        <div className="space-y-12">
          {sections.map((section, i) => (
            <div key={i}>
              <h2 className="h3-display text-xl mb-4">{section.title}</h2>
              <div className="body-md whitespace-pre-line leading-relaxed">{section.content}</div>
            </div>
          ))}
        </div>
      </div>
    </main>
  );
};

export default PrivacyPage;
